import { connect } from 'react-redux'
import Submenu from './Submenu'

const mapStateToProps = ({ router }) => ({
  router
})

export default connect(mapStateToProps)(Submenu)



// WEBPACK FOOTER //
// ./src/app/elements/Submenu/index.js